import {apiSlice} from '../apiSlice';

const NOTIFICATION_URL = '/notifications';

export const notificationsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getNotifications: builder.query({
            query: (token) => ({
                url: `${NOTIFICATION_URL}`,
                method: 'GET',
                headers: {
                    "x-access-token": token
                }
            }),
        }),
        getNotificationList: builder.query({
            query: (token) => ({
                url: `${NOTIFICATION_URL}/get`,
                method: 'GET',
                headers: {
                    "x-access-token": token
                }
            }),
        }),
        readNotification: builder.mutation({
            query: ({token, id}) => ({
                url: `${NOTIFICATION_URL}/isRead/${id}`,
                method: 'PUT',
                headers: {
                    "x-access-token": token
                }
            }),
        }),
        readAllNotification: builder.mutation({
            query: (token) => ({
                url: `${NOTIFICATION_URL}/isReadAll`,
                method: 'PUT',
                headers: {
                    "x-access-token": token
                }
            }),
        }),
        newNotification: builder.mutation({
            query: ({token, data}) => ({
                url: `${NOTIFICATION_URL}/new`,
                method: 'POST',
                body: data,
                headers: {
                    "x-access-token": token
                }
            }),
        }),
    }),
});

export const {
    useGetNotificationsQuery,
    useGetNotificationListQuery,
    useNewNotificationMutation,
    useReadNotificationMutation,
    useReadAllNotificationMutation,
} = notificationsApiSlice;
